require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-mcd-monopoly-2013.json") })
        }
      }, "path---projects-mcd-monopoly-2013");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projects-mcd-monopoly-2013!./.cache/json/projects-mcd-monopoly-2013.json
// module id = 529
// module chunks = 231608221292675